import React, { useEffect, useContext, useReducer } from 'react';
import { store as reportsStore } from '../../reducer';
import { makeStyles } from '@material-ui/core/styles';
import { reducer, initialState, store } from './reducer';
import axios from '../../../../../../api/axios';
import Filters from './Filters';
import List from './List';

const useStyles = makeStyles((theme) => ({
  root: {
    display: 'grid',
    gridTemplateColumns: '1fr',
    gridGap: theme.spacing(1),
  },
}));

const Yearly = () => {
  const classes = useStyles();
  const {
    state: reportsState,
    dispatch: reportsDispatch,
    showMessage,
    showError,
    itemsCountPerPage,
  } = useContext(reportsStore);
  const { Provider } = store;
  const [state, dispatch] = useReducer(reducer, initialState);
  const { startDate, endDate, page } = state;

  const makeReport = async () => {
    try {
      dispatch({ type: 'PROGRESS', payload: true });
      const {
        data: { reports },
      } = await axios.post(`/api/v1/admin/reports/commissionDepositsForUser`, {
        startDate,
        endDate,
        page,
        limit: itemsCountPerPage,
      });
      dispatch({ type: 'REPORTS', payload: reports });
    } catch (error) {
      showError(error);
    }
    dispatch({ type: 'PROGRESS', payload: false });
  };

  useEffect(() => {
    reportsDispatch({
      type: 'CHANGE_TITLE_CATEGORY',
      payload: {
        title: 'گزارش سالیانه ‌پورسانت‌ها',
        category: 'لیست پورسانت های واریزی بصورت سالیانه',
      },
    });
  }, []);
  useEffect(() => {
    makeReport();
  }, [startDate, endDate, page, itemsCountPerPage]);

  return (
    <Provider
      value={{
        state,
        dispatch,
        showMessage,
        showError,
        itemsCountPerPage,
        makeReport,
      }}
    >
      <div className={classes.root}>
        <Filters />
        <List />
      </div>
    </Provider>
  );
};

export default React.memo(Yearly);
